import { render, staticRenderFns } from "./uploader.vue?vue&type=template&id=1a4a79b1"
import script from "./uploader.vue?vue&type=script&lang=js"
export * from "./uploader.vue?vue&type=script&lang=js"
import style0 from "./uploader.vue?vue&type=style&index=0&id=1a4a79b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports